<main class="carousel-shell">
  <button
    type="button"
    class="nav-button nav-button--left"
    (click)="scrollLeft()"
    aria-label="Scroll categories left">
    ‹
  </button>

  <section #carousel class="categories">
    @for (category of categories; track category.id) {
      <button
        type="button"
        class="category"
        [routerLink]="'/'"
        [queryParams]="{ categoryId: category.id}"
        [style.background-image]="'url(' + category.image + ')'"
        >

        <span class="category-name">
          {{ category.name }}
        </span>
      </button>
    }
  </section>

  <button
    type="button"
    class="nav-button nav-button--right"
    (click)="scrollRight()"
    aria-label="Scroll categories right">
    ›
  </button>
</main>
